// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scroll[data-v-1f8cfb3e] {\n  overflow: auto;\n  height: 400px;\n  overflow-x: hidden !important;\n}\n", ""]);
// Exports
module.exports = exports;
